import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';

// Constants
import { BIG_DESKTOP_WIDTH, MAX_SLIDE_VIEW, MIDDLE_SLIDE_VIEW, MIN_SLIDE_VIEW, SMALL_DESKTOP_WIDTH } from "../constants";
export var usePrepareMainTariffs = function usePrepareMainTariffs() {
  var _useState = useState(slidesPer()),
    _useState2 = _slicedToArray(_useState, 2),
    slidesPerValue = _useState2[0],
    setSlidesPer = _useState2[1];
  var handleResize = function handleResize() {
    return setSlidesPer(slidesPer());
  };
  function slidesPer() {
    if (typeof window !== 'undefined') {
      var currentWidth = window.innerWidth;
      if (currentWidth >= BIG_DESKTOP_WIDTH) {
        return MAX_SLIDE_VIEW;
      }
      if (currentWidth >= SMALL_DESKTOP_WIDTH) {
        return MIDDLE_SLIDE_VIEW;
      }
    }
    return MIN_SLIDE_VIEW;
  }
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return slidesPerValue;
};